import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import { CookieConsent } from '@/components/CookieConsent'

import packageJson from '../package.json'
import { useCurrentUser } from './api/auth/queries/useCurrentUser'
import { ToastContainer, ToastProvider } from './components/ui/toast'
import { useIsNewDesign } from './hooks/useIsNewDesign'
import Layout from './Layout'
import { QUERY_KEYS } from './lib/queryKeys'
import NavBar from './NavBar'
import { LoadingScreen } from './pages/client-side/components/LoadingScreen'
import OfficeNavbar from './pages/office-side/OfficeNavbar'
import { RoutePath } from './RoutePath'
//utils
import { currentAuthenticatedUser } from './services/users'
import { setIsAuthenticated } from './store/appSlice'
import { getRatesAction } from './store/packageSlice'

export default function App() {
  const dispatch = useDispatch()
  const history = useHistory()
  const queryClient = useQueryClient()
  const [isReady, setIsReady] = useState(false)
  const { data: loggedUser } = useCurrentUser()
  const location = useLocation()
  const isNewDesign = useIsNewDesign()

  useEffect(() => {
    if (isNewDesign) {
      delete document.body.dataset.bs
      document.body.dataset.twp = ''
    } else {
      delete document.body.dataset.twp
      document.body.dataset.bs = ''
    }
  }, [isNewDesign])

  useEffect(() => {
    // Check if current path is an office page
    const isOfficePage = location.pathname.startsWith('/office') || location.pathname.startsWith('/all-packages-view')

    // Update HTML lang attribute
    if (isOfficePage) {
      document.documentElement.lang = 'en'
    } else {
      document.documentElement.lang = 'he'
    }
  }, [location.pathname])

  useEffect(() => {
    if (window.location.href.includes('office')) {
      const enableToolbar = document.getElementById('enable-toolbar')
      if (enableToolbar) enableToolbar.style.display = 'none'
    }
  }, [])

  useEffect(() => {
    //versioning
    const version = packageJson.version
    const last_version = localStorage.getItem(`version`)
    if (!last_version || last_version !== version) {
      localStorage.setItem(`version`, version)
      window.location.reload()
    }

    //affiliate
    const p = window.location.search
    if (p.includes('?ref')) {
      if (p.includes('&')) {
        localStorage.setItem('ref', p.slice(p.indexOf('?ref=') + 5, p.indexOf('&')))
      } else localStorage.setItem('ref', p.slice(p.indexOf('?ref=') + 5))
    }

    //user auth

    ;(async () => {
      const userData = await currentAuthenticatedUser()
      if (!userData) {
        localStorage.removeItem('cognito-tokens')
        dispatch(setIsAuthenticated(false))
        setIsReady(true)
        return
      }
      let updatedPermission = {
        ...(loggedUser?.permissions || {}),
      }
      userData.groups?.Groups.forEach((group: { GroupName: string }) => {
        updatedPermission = { ...updatedPermission, [group.GroupName]: true }
      })
      queryClient.setQueryData([QUERY_KEYS.LOGGED_USER], { ...userData, permissions: updatedPermission })
      // @ts-expect-error - TODO: fix this
      dispatch(getRatesAction())
      dispatch(setIsAuthenticated(true))
      if (history.location.pathname == '/') history.push(RoutePath.ClientPkg)
      else history.push(history.location.pathname + history.location.search + history.location.hash)
      setIsReady(true)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // useEffect(() => {
  //   if (!loggedUser.Username || ENV === 'dev') return

  //   let inactivityTimeout

  //   const resetInactivityTimeout = () => {
  //     if (inactivityTimeout) clearTimeout(inactivityTimeout)
  //     inactivityTimeout = setTimeout(() => {
  //       localStorage.setItem('logout-reason', 'inactivity')
  //       localStorage.removeItem('cognito-tokens')
  //       window.location.href = '/welcome'
  //     }, 10 * 60 * 1000) // 10 minutes
  //   }

  //   const activityEvents = ['mousemove', 'keydown', 'click', 'touchstart', 'scroll', 'wheel', 'touchmove', 'touchend', 'touchcancel', 'mousedown']
  //   activityEvents.forEach((eventName) => {
  //     window.addEventListener(eventName, resetInactivityTimeout)
  //   })

  //   resetInactivityTimeout()

  //   return () => {
  //     if (inactivityTimeout) clearTimeout(inactivityTimeout)
  //     activityEvents.forEach((eventName) => {
  //       window.removeEventListener(eventName, resetInactivityTimeout)
  //     })
  //   }
  // }, [loggedUser])

  const hardRefresh = () => {
    localStorage.clear()
    history.push('/')
    window.location.reload()
  }

  return (
    <ToastProvider>
      <div className='rootContainer'>
        {!isReady ? (
          <LoadingScreen onRefresh={hardRefresh} />
        ) : (
          <>
            {loggedUser?.permissions['Admin'] ||
            loggedUser?.permissions['Agent'] ||
            loggedUser?.permissions['SeniorAgent'] ||
            loggedUser?.permissions['OfficeManager'] ||
            loggedUser?.permissions['Worker'] ? (
              <OfficeNavbar />
            ) : (
              <NavBar />
            )}
            <Layout />
          </>
        )}
      </div>
      <ToastContainer />
      <CookieConsent />
    </ToastProvider>
  )
}
